import type { ComponentSingleStyleConfig } from '@chakra-ui/theme'

const Badge: ComponentSingleStyleConfig = {
  baseStyle: {
    fontWeight: 600,
  },
  sizes: {},
  variants: {
    round: {
      backgroundColor: '#ff0000',
      color: '#ffffff',
      borderRadius: '50%',
      minWidth: '18px',
      textAlign: 'center',
    },
    ellipse: {
      backgroundColor: '#ff0000',
      color: '#ffffff',
      borderRadius: '20px',
      minWidth: '18px',
      textAlign: 'center',
    },
  },
  defaultProps: {},
}

export default Badge
